// extracted by mini-css-extract-plugin
export var cell = "_61-4";
export var headerCell = "_61-2";
export var rowHeader = "_61-3";
export var table = "_61-1";
export var tableContainer = "_61-0";